/*
 * tg-cdf-mobile-pdp.js
 * CDF-S/L [BASE] スマホ商品ページ改修テスト用（cdf_base_test テンプレート専用）。
 * 並び替えと固定バーはスマホ幅だけ。CSSは snippets/tg-cdf-mobile-pdp.liquid にある。
 * 既存のテーマ部品は編集せず、DOMに印（data-tg-order）を付けるだけにしている。
 */
(() => {
  const root = document.getElementById('tg-cdf-mobile-pdp');
  if (!root || root.dataset.tgInit) return;
  root.dataset.tgInit = '1';

  const THRESHOLD = Number(root.dataset.threshold) || 10000;
  const mq = window.matchMedia('(max-width: 749px)');
  const card = root.querySelector('[data-tg-shell-card]');
  const check = root.querySelector('[data-tg-shell-check]');
  const bar = root.querySelector('[data-tg-bar]');
  const barPrice = root.querySelector('[data-tg-bar-price]');
  const barShip = root.querySelector('[data-tg-bar-ship]');
  const barBtn = root.querySelector('[data-tg-bar-btn]');
  let shellMap = {};
  try {
    const raw = root.querySelector('[data-tg-shell-map]');
    if (raw) shellMap = JSON.parse(raw.textContent);
  } catch (e) {
    shellMap = {};
  }

  const yen = (n) => '¥' + Math.round(n).toLocaleString('ja-JP');
  const container = () => document.querySelector('.product-details > .group-block > .group-block-content');
  const picker = () => document.querySelector('.product-details variant-picker');
  const buyBlock = () => document.querySelector('.product-details .buy-buttons-block');
  const priceEl = () => document.querySelector('.product-details product-price');
  const addButton = () => {
    const b = buyBlock();
    return b ? b.querySelector('button[type="submit"], .add-to-cart-button, button[name="add"]') : null;
  };

  function selectedSize() {
    const p = picker();
    if (!p) return null;
    const checked = [...p.querySelectorAll('input:checked')];
    const bySize = checked.find((i) => /size|サイズ/i.test(i.dataset.optionName || ''));
    return (bySize || checked[0] || {}).value || null;
  }

  function currentPrice() {
    const el = priceEl();
    if (!el) return null;
    const m = el.innerText.match(/¥\s*([\d,]+)/);
    return m ? Number(m[1].replace(/,/g, '')) : null;
  }

  /* ---- 並び順の印付け（スマホ幅でだけCSSが効く） ---- */
  function tagOrder() {
    const c = container();
    if (!c) return;
    c.classList.add('tg-cdf-order');
    const kids = [...c.children];
    const firstGroup = kids.find((k) => k.classList.contains('group-block'));
    kids.forEach((k) => {
      let n = null;
      if (k === firstGroup) n = 1;
      else if (k.matches('variant-picker')) n = 2;
      else if (/^ai-link-button/.test(k.className) && k.tagName === 'DIV') n = 3;
      else if (k.classList.contains('spacer-block')) n = 4;
      else if (k.matches('product-price')) n = 5;
      else if (k.classList.contains('buy-buttons-block')) n = 6;
      else if (k.contains(root)) n = 7;
      else if (k.classList.contains('group-block') && /送料/.test(k.innerText)) n = 8;
      else if (k.classList.contains('group-block') && /永年保証/.test(k.innerText)) n = 9;
      else if (/AIチャット/.test(k.innerText) && k.tagName !== 'STYLE' && k.matches('rte-formatter')) n = 10;
      else if (k.matches('rte-formatter') && /product_description/.test(k.className)) n = 11;
      if (n) k.setAttribute('data-tg-order', String(n));
    });
  }

  /* ---- 商品説明の折りたたみ ---- */
  function setupDescription() {
    const c = container();
    if (!c) return;
    const desc = [...c.children].find((k) => k.matches('rte-formatter') && /product_description/.test(k.className));
    if (!desc) return;
    desc.classList.add('tg-desc');
    if (c.querySelector('.tg-desc-toggle')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tg-desc-toggle';
    btn.textContent = '続きを読む';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const open = desc.classList.toggle('tg-desc--open');
      btn.textContent = open ? '閉じる' : '続きを読む';
      btn.setAttribute('aria-expanded', String(open));
    });
    btn.setAttribute('data-tg-order', '12');
    desc.after(btn);
  }

  /* ---- Filter Shell（同じ径）の提案 ---- */
  function currentShell() {
    const size = selectedSize();
    return size && shellMap[size] ? shellMap[size] : null;
  }

  function updateShell() {
    if (!card) return;
    const size = selectedSize();
    const s = currentShell();
    if (!s || !s.available) {
      card.hidden = true;
      if (check) check.checked = false;
      return;
    }
    card.hidden = false;
    card.querySelector('[data-tg-shell-sub]').textContent = size + ' 用（フロント／リアのセット）';
    card.querySelector('[data-tg-shell-price]').textContent = yen(s.price / 100);
  }

  /* ---- 固定バー ---- */
  function updateBar() {
    const price = currentPrice();
    const s = currentShell();
    const withShell = check && check.checked && s ? s.price / 100 : 0;
    const total = price === null ? null : price + withShell;
    const size = selectedSize();
    barPrice.textContent = total === null ? '' : yen(total);
    if (total === null) barShip.textContent = '';
    else if (total >= THRESHOLD) barShip.textContent = '送料無料の対象です';
    else barShip.textContent = 'あと' + yen(THRESHOLD - total) + 'で送料無料';
    barBtn.textContent = size ? 'カートに追加する' : 'サイズを選ぶ';
  }

  let buyVisible = true;
  let atBottom = false;
  function applyBarVisibility() {
    const show = mq.matches && !buyVisible && !atBottom;
    bar.hidden = !show;
    document.documentElement.classList.toggle('tg-bar-on', show);
    if (show) document.documentElement.style.setProperty('--tg-bar-h', bar.offsetHeight + 'px');
  }

  function observeVisibility() {
    const b = buyBlock();
    if (b) {
      new IntersectionObserver((es) => {
        buyVisible = es[0].isIntersecting;
        applyBarVisibility();
      }).observe(b);
    }
    const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    if (footer) {
      new IntersectionObserver((es) => {
        atBottom = es[0].isIntersecting;
        applyBarVisibility();
      }).observe(footer);
    }
  }

  barBtn.addEventListener('click', () => {
    if (!selectedSize()) {
      const p = picker();
      if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const b = addButton();
    if (b) b.click();
  });

  /* ---- Shellを選んだ場合は、本体とShellを1回の通信でカートへ入れ、そのままカートページへ移動する ----
   * 以前は「Shellを追加 → 本体を追加（テーマの処理）→ 移動」と順番に通信していたため遅く、画面もちらついた。
   * 1回にまとめることで、移動までの待ち時間を本体だけの場合と同程度にする。
   * 失敗したときは何も入らず（全部まとめて失敗する）、ページにとどまってメッセージを出す。 */
  const cartUrl = root.dataset.cartUrl || '/cart';
  const note = card ? card.querySelector('.tg-shell-card__note') : null;
  const noteDefault = note ? note.textContent : '';
  let busy = false;

  function setBusy(on) {
    busy = on;
    const b = addButton();
    if (b) {
      b.setAttribute('aria-busy', String(on));
      b.style.opacity = on ? '0.6' : '';
      b.style.pointerEvents = on ? 'none' : '';
    }
    barBtn.disabled = on;
    barBtn.textContent = on ? '追加中…' : barBtn.textContent;
    if (!on) updateBar();
  }

  async function addTogether(b, s) {
    const form = b.closest('form') || (buyBlock() && buyBlock().querySelector('form'));
    const idInput = form && form.querySelector('[name="id"]');
    const qtyInput = form && form.querySelector('[name="quantity"]');
    const mainId = idInput && Number(idInput.value);
    if (!mainId) return false;
    const qty = (qtyInput && Number(qtyInput.value)) || 1;
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: mainId, quantity: qty }, { id: s.id, quantity: 1 }] }),
    });
    return res.ok;
  }

  document.addEventListener(
    'click',
    async (e) => {
      if (!mq.matches || !check || !check.checked) return;
      const b = addButton();
      if (!b || !(e.target instanceof Element) || !b.contains(e.target)) return;
      const s = currentShell();
      if (!s || !s.available) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      setBusy(true);
      let ok = false;
      try {
        ok = await addTogether(b, s);
      } catch (err) {
        ok = false;
      }
      if (ok) {
        window.location.assign(cartUrl);
        return; // 移動するまで「追加中」のままにして、ちらつきを防ぐ
      }
      setBusy(false);
      if (note) {
        note.textContent = '追加できませんでした。Shellのチェックを外すか、時間をおいてもう一度お試しください。';
        setTimeout(() => { note.textContent = noteDefault; }, 6000);
      }
    },
    true
  );

  function refresh() {
    tagOrder();
    setupDescription();
    updateShell();
    updateBar();
  }

  let raf = 0;
  const schedule = () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(refresh);
  };

  document.addEventListener('change', schedule);
  if (check) check.addEventListener('change', updateBar);
  const c = container();
  if (c) {
    new MutationObserver((muts) => {
      // 自分の書き換え（カードやバーの中身）では再実行しない（無限ループ防止）
      if (muts.every((m) => root.contains(m.target) || (m.target.classList && m.target.classList.contains('tg-desc-toggle')))) return;
      schedule();
    }).observe(c, { childList: true, subtree: true, characterData: true });
  }
  mq.addEventListener('change', applyBarVisibility);

  refresh();
  observeVisibility();
})();
